import { render, staticRenderFns } from "./DepartamentoPessoalExportadorSenior.vue?vue&type=template&id=1398ffb2&scoped=true"
import script from "./DepartamentoPessoalExportadorSenior.vue?vue&type=script&lang=js"
export * from "./DepartamentoPessoalExportadorSenior.vue?vue&type=script&lang=js"
import style0 from "./DepartamentoPessoalExportadorSenior.vue?vue&type=style&index=0&id=1398ffb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1398ffb2",
  null
  
)

export default component.exports